var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHugeiconsCash02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21C3.333 21.622 5.083 22 7 22C8.917 22 10.668 21.622 12 21C13.332 20.378 15.083 20 17 20C18.917 20 20.668 20.378 22 21M12 18C10.668 18.622 8.917 19 7 19C5.934 19 4.92 18.883 4 18.673C3.409 18.537 3.113 18.47 2.759 18.189C2.52733 17.9907 2.33558 17.7501 2.194 17.48C2 17.073 2 16.677 2 15.886V5.114C2 4.129 3.04 3.453 4 3.673C4.92 3.883 5.934 4 7 4C8.917 4 10.668 3.622 12 3C13.332 2.378 15.083 2 17 2C18.066 2 19.08 2.117 20 2.327C20.591 2.463 20.887 2.531 21.241 2.811C21.443 2.971 21.695 3.287 21.806 3.52C22 3.928 22 4.323 22 5.114V15.886C22 16.871 20.96 17.547 20 17.327C19.08 17.117 18.066 17 17 17C15.083 17 13.332 17.378 12 18Z",
    stroke: "#C0C0C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.5V11.509M18.5 9.492V9.502M14.5 10.5C14.5 11.163 14.2366 11.7989 13.7678 12.2678C13.2989 12.7366 12.663 13 12 13C11.337 13 10.7011 12.7366 10.2322 12.2678C9.76339 11.7989 9.5 11.163 9.5 10.5C9.5 9.83696 9.76339 9.20107 10.2322 8.73223C10.7011 8.26339 11.337 8 12 8C12.663 8 13.2989 8.26339 13.7678 8.73223C14.2366 9.20107 14.5 9.83696 14.5 10.5Z",
    stroke: "#C0C0C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsCash02);
export default __webpack_public_path__ + "static/media/hugeicons_cash-02.9aa91752494ae591d721c0f9376c2286.svg";
export { ForwardRef as ReactComponent };